import types from './actionTypes';

const initialState = {
  affiliates: [],
  loading: false,
  error: null,
  message: null,
};

const affiliateReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_AFFILIATE_STATE:
      return initialState;
    case types.CREATE_AFFILIATE.REQUEST:
    case types.UPDATE_AFFILIATE.REQUEST:
    case types.SYNC_AFFILIATES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CREATE_AFFILIATE.SUCCESS:
      return {
        ...state,
        loading: false,
        affiliates: [...state.affiliates, action.affiliate],
        message: 'Affiliato creato con successo',
      };

    case types.SYNC_AFFILIATES.SUCCESS:
      return {
        ...state,
        loading: false,
        affiliates: [...action.affiliates],
      };

    case types.UPDATE_AFFILIATE.SUCCESS:
      return {
        ...state,
        loading: false,
        affiliates: state.affiliates.map((affiliate) =>
          affiliate.id === action.affiliate.id ? action.affiliate : affiliate,
        ),
        message: 'Affiliato aggiornato con successo',
      };

    case types.CREATE_AFFILIATE.FAILURE:
    case types.UPDATE_AFFILIATE.FAILURE:
    case types.SYNC_AFFILIATES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default affiliateReducer;
